<template>
  <picture>
    <source
      v-if="extraWideValue"
      media="(min-width: 1600px)"
      :srcset="srcset(src, extraWideValue)"
    >
    <source
      v-if="wideValue"
      media="(min-width: 1200px)"
      :srcset="srcset(src, wideValue)"
    >
    <source
      v-if="desktopValue"
      media="(min-width: 992px)"
      :srcset="srcset(src, desktopValue)"
    >
    <source
      v-if="tabletValue"
      media="(min-width: 768px)"
      :srcset="srcset(mobileSrcValue, tabletValue, true)"
    >
    <img
      v-if="mobile"
      :class="imgClass"
      :src="resize(mobileSrcValue, mobile)"
      :srcset="srcset(mobileSrcValue, mobile, true)"
      :alt="alt"
      :loading="loading"
      :fetchpriority="fetchpriority"
      :width="width"
      :height="height"
    >
    <img
      v-else
      :class="imgClass"
      :src="mobileSrcUrl"
      :alt="alt"
      :loading="loading"
      :fetchpriority="fetchpriority"
      :width="width"
      :height="height"
    >
    <slot />
  </picture>
</template>

<script>
import imageResizer from '@/utils/image-resizer'

export default {
  props: {
    src: {
      type: [Object, String],
      required: true
    },
    mobileSrc: {
      type: [Object, String],
      default: null
    },
    imgClass: {
      type: String,
      default: null
    },
    mobile: {
      type: Array,
      default: () => [375, 0]
    },
    tablet: {
      type: Array,
      default: null
    },
    desktop: {
      type: Array,
      default: null
    },
    wide: {
      type: Array,
      default: null
    },
    extraWide: {
      type: Array,
      default: null
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: null
    },
    imageResizer: {
      type: Object,
      default: () => ({ name: 'ImageResizingNet' })
    },
    alt: {
      type: String,
      default: ''
    },
    lazy: {
      type: Boolean,
      default: false
    },
    parallax: {
      type: Boolean,
      default: false
    },
    fetchpriority: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      required: true
    },
    height: {
      type: String,
      required: true
    }
  },
  data() {
    const mobileSrcValue = this.mobileSrc ?? this.src
    let tabletValue = this.tablet
    let desktopValue = this.desktop
    let wideValue = this.wide
    let extraWideValue = this.extraWide
    const mobileSrcUrl = mobileSrcValue?.url || mobileSrcValue
    const loading = this.lazy ? 'lazy' : null

    if (this.fullWidth) {
      tabletValue ??= [720, 0]
      desktopValue ??= [960, 0]
      wideValue ??= [1500, 0]
      extraWideValue ??= [1920, 0]
    }

    return {
      mobileSrcValue,
      tabletValue,
      desktopValue,
      wideValue,
      extraWideValue,
      mobileSrcUrl,
      loading
    }
  },
  methods: {
    resize(src, sizes) {
      let scale = 1
      if (this.parallax) {
        scale = 1.5
      }

      const resizer = imageResizer[this.imageResizer.name]
      return resizer.resize(src, sizes[0] * scale, sizes[1] * scale, this.options)
    },
    srcset(src, sizes, add2x = false) {
      const defaultSize = this.resize(src, sizes)

      if (!add2x) {
        return defaultSize
      }

      const multipliedSize = this.resize(src, [sizes[0] * 2, sizes[1] * 2])
      return `${defaultSize}, ${multipliedSize} 2x`
    }
  }
}
</script>
